import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ConsentPrompt() {
  const { user, setUser } = useAuth();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = !!user && user.role === "student" && !user.consent?.given_at && !user.impersonating;

  useEffect(() => { if (open) api.get("/consent/text").then(({ data }) => setInfo(data)).catch(() => {}); }, [open]);

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/consent/accept");
      setUser({ ...user, consent: { version: info?.version, given_at: new Date().toISOString(), withdrawn_at: null } });
      toast.success("Thanks — you're all set");
    } catch { toast.error("Could not save, please try again"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open}>
      <DialogContent className="rounded-none max-w-lg border-2 border-[#0F1F2E]" data-testid="consent-prompt" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <div className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#25AAAA]">One quick thing</div>
        <h2 className="font-display text-2xl font-black tracking-tighter leading-tight">Programme emails</h2>
        <p className="text-sm text-[#525252] leading-relaxed">We email students about iTeams — team announcements, session details, surveys and attendance follow-ups. Please confirm you're happy for us to do that.</p>
        <p className="text-xs border border-[#E5E7EB] p-3 leading-relaxed" data-testid="consent-prompt-text">{info?.text || "…"}</p>
        <p className="text-[11px] text-[#525252]">Read the <a href="/privacy" target="_blank" className="text-[#25AAAA] underline">privacy notice</a>. You can stop emails any time from your dashboard.</p>
        <Button onClick={accept} disabled={busy} className="w-full h-11 rounded-none bg-[#25AAAA] hover:bg-[#1e7d7d] uppercase tracking-wide text-xs font-semibold" data-testid="consent-prompt-accept">
          {busy ? "Saving…" : "I agree"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
